import React from "react";
import BaseCard from "./BaseCard";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import CardHeader from "./CardHeader";
import NoteCard from "./NoteCard";
import DataTable from "../../../../Elements/DataTable/DataTableFigma";
import moneyHelper from '../../../../Helpers/moneyHelper';

class ClientRevenueCard extends BaseCard {
  FieldsToShowInDataTable() {
    return [
      { label: 'Tier Name', data: 'Name', type: InputTypesEnum.TextReadOnly, tableminWidth: '500px' },
      {
        label: 'Per Evaluation',
        data: 'ClientFeePerEval',
        type: InputTypesEnum.Text2,
        tableminWidth: '125px',
        headerPosition: '',
        fieldType: 'Decimal',
      },
      {
        label: 'Revenue Per Cycle',
        data: 'ClientFeePerCycle',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: 'Revenue Per Year',
        data: 'ClientFeeAnnually',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: '% each tier',
        data: 'ClientFeePct',
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  }

  FieldsToShowInFooterDataTable() {
    return [
      { label: '', data: '', tableminWidth: '500px' },
      {
        label: 'TOTAL CLIENT REVENUE',
        data: '',
        type: InputTypesEnum.Text2,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      { label: '', data: 'ClientFeePerCycleTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '', data: 'ClientRevenueTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '', data: 'ClientFeePctTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }

  render() {
    return (
      <div className='card'>
        {
          <CardHeader
            sectionNumber={'2A'}
            HeaderText={'CLIENT REVENUE'}
            changeBodyStatus={this.changeBodyStatus}
            bodyactive={this.state.bodyactive}
            subtotal={moneyHelper.toMoneyFormat(this.props.Tier.ClientRevenueTotal, this.props.Tier.PricingDetails.CurrencyCode)}
            subtotalRev={this.props.Tier.ClientFeePctTotal + ' of revenue'}
          />
        }
        {this.state.bodyactive ? (
          <div>
            <NoteCard
              noteActive={this.state.noteActive}
              renderInputField={this.renderInputField}
              name='ClientRevenueNotes'
              value={this.props.Tier.PricingDetails}
            />
            <DataTable
              type={{
                FieldsToShowInDataTable: this.FieldsToShowInDataTable,
                NameOfTheIdField: () => 'TierId',
                FieldsToShowInListTable: [],
                MoneyFields: this.MoneyFields,
                Currency: this.Currency,
              }}
              itemList={this.props.Tier.TierList}
              renderInputFieldFunction={this.renderInputField}
              thereIsNoSuchRowMessageCheck={false}
              smallDataTable={true}
            />
          </div>
        ) : null}
        <footer>
          <DataTable
            type={{
              FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
              MoneyFields: this.MoneyFields,
              Currency: this.Currency,
            }}
            headeritemList={this.props.Tier}
            thereIsNoSuchRowMessageCheck={false}
            smallDataTable={true}
          />
        </footer>
      </div>
    );
  }
}

export default ClientRevenueCard;
